<template>
  <campsite-subsection
    v-show="notices || campsiteNotices.length"
    name="notices"
    class="notices"
  >
    <template #title>
      <img
        loading="lazy"
        src="@/assets/images/exclamation-mark.svg"
        width="32"
        height="32"
        alt=""
      />
      <translate>Please note</translate>
    </template>
    <template #contents>
      <slot />
      <campsite-notices
        :warnings="warnings"
        :notices="notices"
        :notices-needs-translation="noticesNeedsTranslation"
        :campsite-notices="campsiteNotices"
      />
    </template>
  </campsite-subsection>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import type { CampsiteNotices } from '../../../campsite-details/types'

@Component
class CampsiteNoticesSubsection extends Vue {
  @Prop()
  notices: string

  @Prop({ default: false })
  noticesNeedsTranslation: boolean

  @Prop()
  campsiteNotices: CampsiteNotices[]

  @Prop({ default: () => [] })
  warnings: string[]
}

export default toNative(CampsiteNoticesSubsection)
</script>
<style scoped>
.notices :deep(header) {
  margin-left: -0.75em;
}
</style>
